/**
 * @class TS.domain.EditDomain
 * @extends TS.domain.Domain
 * @classdesc View model for editing an entity.
 */
TS.domain.EditDomain = new Class(
/** @lends TS.domain.EditDomain# */
{

	Extends: TS.domain.Domain,
	showSuccessConfirmation: true,
	isPopup: false,
	events: ['save', 'close'],

	/**
     * The document this view model is editing (data model).
     * Received from server as a JSON graph, all leaf properties are being
     * converted to {@link http://knockoutjs.com/documentation/observables.html observables}
     * using the {@link http://knockoutjs.com/documentation/plugins-mapping.html Mapping} plugin.
     * @member {Object}
     */
	Document: null,

	_cmdHandlers: {
		'Record.Save': 'save',
		'Record.Close': 'close'
	},

	initialize: function (config) {
		var me = this;

		this.parent(config);
	},

	//region Validation

	_resetValidationContext: function () {
		var me = this;

		me._validationContext = {
			isValid: true,
			errors: []
		};
	},

	/**
     * Adds a validation message that will be displayed to the user.
     * @param error {String} Validation message.
     */
	addValidationError: function (error) {
		var me = this,
            ctx = me._validationContext;
		ctx.isValid = false;
		ctx.errors.push(error);
	},

	/**
     * Executes before saving and allows custom validations to be performed, before submitting data to server.
     *
     * @example
     *
     * validateDomain: function(){
     *   var me = this,
     *       isValid,
     *       doc = me.Document,
     *       start = doc.StartDate && doc.StartDate(),
     *       end = doc.EndDate&& doc.EndDate();
     *
     *   me.parent();
     *
     *   start = doc.StartDate && doc.StartDate(),
     *   end = doc.EndDate&& doc.EndDate();
     *
     *   if (start > end) {
     *     me.addValidationError('End date must be later than start date');
     *     return;
     *   }
     * }
     */
	validateDomain: function () {
		var me = this;
		me._resetValidationContext();
	},

	//endregion

	/**
     * Saves model data but first it performs client-side validation.
     */
	save: function (callback) {
		var me = this,
            isPopup = TS.unwrap(me.isPopup),
            msg;

		me.validateDomain();

		if (me._validationContext.isValid !== true) {
			msg = me._validationContext.errors.join('<br>');
			msg = msg || TS.cultures.current.edit.InvalidDocument;
			TS.Notify.error(msg, 'Invalid document');
			me._resetValidationContext();
			return;
		}

		if (!isPopup) {
			me.performServerCommand({
				cmd: 'Save',
				submitModel: true,
				callback: function () {
					if (TS.isFunction(callback))
						callback.apply(me, arguments);
				}
			});
		}
		else {
			me.isSaving = true;
			me.performServerCommand({
				cmd: 'Save',
				submitModel: true,
				callback: function (result) {
					var notifications = TS.Util.getNotifications(result);
					var success = !(notifications.validationerrors || notifications.errors);
					if (success) {
						//me._events = events_backup;
						me.trigger('save'); // call save event handler

						// check if current model was removed froms stack and inform the server only if the model was not removed.
						//if(result.modelData && result.modelData.modelUID == this.modelUID) {
						//    TS.domain.Domain.prototype.close.call(me, true, true, false, {close: true});
						//}
					}

					if (TS.isFunction(callback))
						callback.apply(me, arguments);

					me.isSaving = false;
				}
			});
		}
	}
});